module.exports = [
    "Mkungile",
    "Shabani",
    "Mwaulanga",
    "Mohammed",
    "Musa",
    "Raphael",
    "Shemm",
    "Moses",
    "Baraka",
    "Kaijage",
    "Sebastian",
    "Richard",
    "Samwel",
    "Joshua",
    "Mdoe",
    "Baruti",
    "Benson",
    "John",
    "Pombe",
    "Jullius",
    "Jackson",
    "Faraji",
    "Mohammed",
    "Issa",
    "Salum",
    "Salim",
    "Neon",
    "Amani",
    "McDonald",
    "Majule",
    "Christopher",
    "Masaka",
    "Kabona",
    "Kanzu",
    "Modest",
    "Dewji",
    "Ally",
    "Fadhil",
    "Nassor",
    "Nashon",
    "Matiku",
    "Danieli",
    "Anthony"



]